let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cZgN3")).then(() => parcelRequire('1soyt'));